import { DeleteIcon } from "Components/Icons/DeleteIcon";
import { EditIcon } from "Components/Icons/EditIcon";
import * as React from "react";
import {Button} from "react-bootstrap";

interface ActionWrapperProps<T> {
    data: T
    onEdit?: (data: T) => void
    onDelete?: (data: T) => void
    idKey?: string
}

export class ActionWrapper<T> extends React.Component<ActionWrapperProps<T>> {

    handleClickEdit = () => {
        this.props.onEdit!(this.props.data);
    };

    handleClickDelete = () => {
        this.props.onDelete!(this.props.data);
    };

    render(){
        const id = this.props.data[this.props.idKey || "id"] || "";
        return (
            <div className="container action-basic-group">
                {
                    this.props.onEdit &&
                    <Button
                        variant="icon"
                        id={ `crud-table-category-edit-${ id }` }
                        onClick={ this.handleClickEdit }
                        style={{ padding: "0 5px 0 0", fontSize: 18 }}
                        className="edit-btn"
                    >
                        <EditIcon />
                    </Button>
                }
                {
                    this.props.onDelete ?
                    <Button
                        variant="icon"
                        id={ `crud-table-category-delete-${ id }` }
                        onClick={ this.handleClickDelete }
                        style={{ padding: "0 5px 0 0", fontSize: 18 }}
                        className="delete-btn"
                    >
                        <DeleteIcon />
                    </Button>
                    : null
                }
            </div>
        );
    }
}

